// Form URLs for different languages
// Replace the BN variants when you have distinct Bangla forms

export const JOIN_FORM_URL_EN = 'https://docs.google.com/forms/d/e/1FAIpQLSeRbkOz-H7hRlEBiJtUe8RzK2hOjhG-3i2OyogN1DoxfcMP4Q/viewform';
export const JOIN_FORM_URL_BN = 'https://docs.google.com/forms/d/e/1FAIpQLSckXPAKlyxEuFyaKD1bin2k4CeIPBg6lIVJRj4H9P9u89njmQ/viewform';

export const VOLUNTEER_FORM_URL_EN = 'https://docs.google.com/forms/d/e/1FAIpQLScHQQMOd5EStX4WeMPmE5ejgW_mowmjav-x38gLeFIoyASOIQ/viewform';
export const VOLUNTEER_FORM_URL_BN = 'https://docs.google.com/forms/d/e/1FAIpQLSepy9WVlEtKD6G3K9kyvUeYVisrmdTh8M2xsZm3Y7-z3i1TPQ/viewform';

export const getJoinFormUrl = (language) => (
    language === 'english' ? JOIN_FORM_URL_EN : JOIN_FORM_URL_BN
);

export const getVolunteerFormUrl = (language) => (
    language === 'english' ? VOLUNTEER_FORM_URL_EN : VOLUNTEER_FORM_URL_BN
);


